import type { NavGroupProps } from 'src/components/nav-section';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/config-global';

import { Label } from 'src/components';
import { SvgColor } from 'src/components/svg-color';

export type pathNavManage = 'administrator' | 'manage';

const icon = (name: string) => (
  <SvgColor src={`${CONFIG.site.basePath}/assets/icons/lms-smartx-icon/${name}.svg`} />
);
export const Icons = {
  calendar: icon('icon-calendar'),
  certificate: icon('icon-certificate'),
  chat: icon('icon-chat'),
  course: icon('icon-course'),
  dashboard: icon('icon-dashboard'),
  email: icon('icon-email'),
  export: icon('icon-export'),
  folder: icon('icon-folder'),
  hostEmail: icon('icon-host-email'),
  notify: icon('icon-notify'),
  order: icon('icon-order'),
  question: icon('icon-question'),
  regulation: icon('icon-regulation'),
  storage: icon('icon-storage'),
  subdomain: icon('icon-subdomain'),
  systemAccess: icon('icon-system-access'),
  systemLogs: icon('icon-system-logs'),
  troubleshooting: icon('icon-troubleshooting'),
  user: icon('icon-user'),
  wishList: icon('icon-wishlist'),
  contribution: icon('icon-contribution'),
};

export const navDataManage = (path: pathNavManage): NavGroupProps[] => [
  {
    subheader: 'HỌC VIÊN',
    items: [{ title: 'Học tập', path: paths[path].learningprogress, icon: Icons.dashboard }],
  },
  {
    subheader: 'THỐNG KÊ',
    items: [
      { title: 'Người dùng', path: paths[path].root, icon: Icons.dashboard },
      { title: 'Khóa học', path: paths[path].general.courseAnalytics, icon: Icons.course },
      // { title: 'Bunny', path: paths[path].general.fileAnalytics, icon: Icons.storage },
    ],
  },
  {
    subheader: 'Quản lý',
    items: [
      {
        title: 'Người dùng',
        path: paths[path].user.root,
        icon: Icons.user,
        children: [
          { title: 'Danh sách người dùng', path: paths[path].user.list },
          { title: 'Thêm mới người dùng', path: paths[path].user.new },
          { title: 'Thêm mới người dùng bằng Excel', path: paths[path].user.excel },
          { title: 'Danh sách người dùng đang hoạt động', path: paths[path].user.online },
          { title: 'Khu vực', path: paths[path].user.location },
          { title: 'Nhóm người dùng', path: paths[path].user.group },
          { title: 'Phòng ban', path: paths[path].user.department },
          { title: 'Chức vụ', path: paths[path].user.position },
        ],
      },
      {
        title: 'Khóa học',
        path: paths[path].courseManage.root,
        icon: Icons.course,
        children: [
          {
            title: 'Quản lý khóa học',
            path: paths[path].courseManage.root,
            children: [
              // { title: 'Tree Folder', path: paths[path].courseManage.root },
              { title: 'Danh sách', path: paths[path].courseManage.table },
              { title: 'Thêm học viên', path: paths[path].courseManage.addUserToCoude },
              { title: 'Thêm mới khóa học', path: paths[path].courseManage.new },
            ],
          },
          // {
          //   title: 'Quản lý bài giảng',
          //   path: paths[path].courseManage.root,
          //   children: [
          //     { title: 'Danh sách', path: paths[path].courseManage.table },
          //     { title: 'Thêm mới', path: paths[path].courseManage.addUserToCoude },
          //   ],
          // },
          { title: 'Xem/Chấm bài tự luận', path: paths[path].courseManage.assignmentList },
          // { title: 'Thêm khóa học con', path: paths[path].courseManage.addChildCourse },
          { title: 'Danh mục khóa học', path: paths[path].courseManage.category },
          // { title: 'Khóa học đóng góp', path: paths[path].courseManage.contribution },
        ],
      },
      { title: 'Đơn hàng', path: paths[path].orderManage.root, icon: Icons.chat },
      {
        title: 'Câu hỏi/Đề thi/Khảo sát',
        path: paths[path].question.question.list,
        icon: Icons.question,
        children: [
          {
            title: 'Quản lý câu hỏi',
            path: paths[path].question.question.list,
            children: [
              { title: 'Danh sách câu hỏi', path: paths[path].question.question.list },
              { title: 'Thêm mới câu hỏi', path: paths[path].question.question.create },
              { title: 'Thêm mới câu hỏi (excel)', path: paths[path].question.question.excel },
            ],
          },
          // {
          //   title: 'Bộ câu hỏi',
          //   path: paths[path].question.groups.list,
          //   children: [
          //     { title: 'Danh sách bộ câu hỏi', path: paths[path].question.groups.list },
          //     { title: 'Thêm mới bộ câu hỏi', path: paths[path].question.groups.create },
          //   ],
          // },
          {
            title: 'Ngân hàng đề thi',
            path: paths[path].question.exam.list,
            children: [
              { title: 'Danh sách đề thi', path: paths[path].question.exam.list },
              { title: 'Thêm mới đề thi ', path: paths[path].question.exam.create },
            ],
          },
          {
            title: 'Khảo sát',
            path: paths[path].question.survey.list,
            children: [
              { title: 'Danh sách khảo sát', path: paths[path].question.survey.list },
              { title: 'Thêm mới khảo sát', path: paths[path].question.survey.create },
              { title: 'Thêm mới khảo sát trước khóa học', path: paths[path].question.survey.preCourse },
            ],
          },
        ],
      },
      {
        title: 'Email',
        path: paths[path].email.root,
        icon: Icons.email,
        children: [
          {
            title: 'Email',
            path: paths[path].email.root,
            info: (
              <Label color="error" variant="inverted">
                +32
              </Label>
            ),
          },
          { title: 'Mẫu Email', path: paths[path].email.template },
        ],
      },
      {
        title: 'Thông báo',
        path: paths[path].notify.root,
        icon: Icons.notify,
        children: [
          { title: 'Danh sách thông báo', path: paths[path].notify.root },
          { title: 'Thêm mới thông báo', path: paths[path].notify.new },
        ],
      },
      {
        title: 'Chứng chỉ',
        path: paths[path].certificate.root,
        icon: Icons.certificate,
        children: [
          { title: 'Danh sách chứng chỉ', path: paths[path].certificate.root },
          { title: 'Thêm mới chứng chỉ', path: paths[path].certificate.new },
          { title: 'Thêm chứng chỉ theo danh sách', path: paths[path].certificate.bulk },
        ],
      },
      {
        title: 'Lịch',
        path: paths[path].calendarManage.root,
        icon: Icons.calendar,
        children: [
          // {
          //   title: 'Lịch học',
          //   path: paths[path].calendarManage.schedule.root,
          //   children: [
          //     {
          //       title: 'Danh sách lịch học',
          //       path: paths[path].calendarManage.schedule.root,
          //     },
          //     { title: 'Thêm lịch học', path: paths[path].calendarManage.schedule.new },
          //   ],
          // },
          {
            title: 'Lịch họp',
            path: paths[path].calendarManage.meetingSchedule.root,
            children: [
              {
                title: 'Danh sách lịch họp',
                path: paths[path].calendarManage.meetingSchedule.root,
              },
              {
                title: 'Thêm lịch họp',
                path: paths[path].calendarManage.meetingSchedule.new,
              },
            ],
          },
          // {
          //   title: 'Lịch thi',
          //   path: paths[path].calendarManage.testSchedule.root,
          //   children: [
          //     {
          //       title: 'Danh sách lịch thi',
          //       path: paths[path].calendarManage.testSchedule.root,
          //     },
          //     { title: 'Thêm lịch thi', path: paths[path].calendarManage.testSchedule.new },
          //   ],
          // },
        ],
      },
      {
        title: 'Xuất báo cáo',
        path: paths[path].exportReport.root,
        icon: Icons.export,
        children: [
          { title: 'Báo cáo chi tiết', path: paths[path].exportReport.detailReport },
          // { title: 'Báo cáo tuần', path: paths[path].exportReport.weeklyReport },
          // {
          //   title: 'Báo cáo bảng điểm cuối khóa',
          //   path: paths[path].exportReport.academicTranscript,
          // },
          // { title: 'Biểu đồ thống kê', path: paths[path].exportReport.chartReport },
        ],
      },
      { title: 'Chat', path: paths[path].chat, icon: Icons.chat },
      {
        title: 'Tin tức & Sự kiện',
        path: paths[path].new.root,
        icon: Icons.chat,
        children: [
          {
            title: 'Danh sách',
            path: paths[path].new.root,
          },
          {
            title: 'Thêm mới',
            path: paths[path].new.action.create,
          },
        ],
      },
    ],
  },
  {
    subheader: 'Mở rộng',
    items: [
      { title: 'Tập tin', path: paths[path].fileManager, icon: Icons.folder },
      {
        title: 'Truy cập vào hệ thống',
        path: paths[path].extends.systemAccess,
        icon: Icons.systemAccess,
      },
      {
        title: 'System log',
        path: paths[path].extends.systemLogs,
        icon: Icons.systemLogs,
      },
    ],
  },
  {
    subheader: 'Thiết lập',
    items: [
      {
        title: 'Quy chế qua bài',
        path: paths[path].settings.regulation,
        icon: Icons.regulation,
      },
      {
        title: 'HostEmail',
        path: paths[path].settings.emailSetting,
        icon: Icons.hostEmail,
      },
      {
        title: 'Subdomain',
        path: paths[path].settings.subdomain,
        icon: Icons.subdomain,
      },
    ],
  },
];
